import { render, staticRenderFns } from "./ReceiveCoins.vue?vue&type=template&id=670e40e6&"
import script from "./ReceiveCoins.vue?vue&type=script&lang=js&"
export * from "./ReceiveCoins.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveCoins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports